import { useState, useEffect } from 'react'
import { useParams, Outlet } from 'react-router-dom'
import { apiUrl } from '../../config/api'

// Cache global — não refaz a validação se já validou esse slug
const validatedSlugs = new Set<string>()

export default function OrgGuard() {
  const { slug } = useParams()
  const [status, setStatus] = useState<'loading' | 'valid' | 'invalid'>(
    validatedSlugs.has(slug || '') ? 'valid' : 'loading'
  )

  useEffect(() => {
    if (!slug) { setStatus('invalid'); return }
    if (validatedSlugs.has(slug)) { setStatus('valid'); return }

    fetch(apiUrl(`/v1/community/${slug}/config`), {
      headers: { Accept: 'application/json' },
    })
      .then(res => {
        if (res.ok) validatedSlugs.add(slug)
        setStatus(res.ok ? 'valid' : 'invalid')
      })
      .catch(() => { validatedSlugs.add(slug); setStatus('valid') })
  }, [slug])

  if (status === 'loading') {
    return <div className="min-h-dvh bg-surface-primary" />
  }

  if (status === 'invalid') {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-white px-6">
        <div className="text-center max-w-sm">
          <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🔍</span>
          </div>
          <h1 className="text-xl font-bold text-gray-900 mb-2">Comunidade não encontrada</h1>
          <p className="text-sm text-gray-500 mb-6">
            Não encontramos nenhuma comunidade com o endereço <strong className="text-gray-700">/{slug}</strong>. Verifique se o link está correto.
          </p>
          <a href="/" className="inline-block px-6 py-2.5 rounded-xl bg-gray-900 text-white text-sm font-medium hover:bg-gray-800 transition-colors">
            Voltar ao início
          </a>
        </div>
      </div>
    )
  }

  return <Outlet />
}
